import DOM from '@/dom/dom'
import '@/dom/polyfills/index'
import store from '@/Store'
import Connection from '@/connection'
import Polling from '@/component/Polling'
import Component from '@/component/index'
import { dispatch, wireDirectives } from '@/util'
import FileUploads from '@/component/FileUploads'
import LaravelEcho from '@/component/LaravelEcho'
import DirtyStates from '@/component/DirtyStates'
import DisableForms from '@/component/DisableForms'
import FileDownloads from '@/component/FileDownloads'
import LoadingStates from '@/component/LoadingStates'
import OfflineStates from '@/component/OfflineStates'
import SyncBrowserHistory from '@/component/SyncBrowserHistory'
import SupportAlpine from '@/component/SupportAlpine'
import SupportStacks from '@/component/SupportStacks'

class Livewire {
    constructor() {
        this.connection = new Connection()
        this.components = store
        this.devToolsEnabled = false
        this.onLoadCallback = () => { }
    }

    getWire = id => this.components.componentsById[id]?.$wire;
    first = () => this.getWire(Object.keys(this.components.componentsById)[0]);
    find = this.getWire;
    all = () => Object.values(this.components.componentsById).map(c => c.$wire);

    directive = (name, cb) => this.components.registerDirective(name, cb);
    hook = (name, cb) => this.components.registerHook(name, cb);
    onLoad = cb => (this.onLoadCallback = cb);
    onError = cb => (this.components.onErrorCallback = cb);

    emit = (event, ...params) => this.components.emit(event, ...params);
    emitTo = (name, event, ...params) => this.components.emitTo(name, event, ...params);
    on = (event, cb) => this.components.on(event, cb);

    addHeaders = headers => Object.assign(this.connection.headers, headers);
    devTools = enable => (this.devToolsEnabled = enable);

    restart = () => (this.stop(), this.start());
    stop = () => this.components.tearDownComponents();

    start() {
        DOM.rootComponentElementsWithNoParents().forEach(el => {
            try { this.components.addComponent(new Component(el, this.connection)); } catch (error) {} });

        this.onLoadCallback();
        dispatch('livewire:load');

        document.addEventListener('visibilitychange',
            () => (this.components.livewireIsInBackground = document.hidden),
            false
        );

        this.components.initialRenderIsFinished = true;
    }

    rescan(node = null) {
        DOM.rootComponentElementsWithNoParents(node).forEach(el => {
            try {
                const componentId = wireDirectives(el).get('id').value;
                if (!this.components.hasComponent(componentId)) {
                    this.components.addComponent(new Component(el, this.connection));
                }
            } catch (error) {}
        });
    }

    delay = ms => setTimeout(() => {}, ms);

    stop_dir(node = null) {
        node.querySelectorAll('[wire\\:id]').forEach(el => {
            try {
                const componentId = wireDirectives(el).get('id').value;
                if (this.components.hasComponent(componentId)) {
                    this.components.removeComponent(this.components.findComponent(componentId));
                }
            } catch (error) {}
        });
    }

    onPageExpired(callback) {
        this.components.sessionHasExpiredCallback = callback
    }
}

if (!window.Livewire) {
    window.Livewire = Livewire
}

[
    SyncBrowserHistory,
    SupportAlpine,
    SupportStacks,
    FileDownloads,
    OfflineStates,
    LoadingStates,
    DisableForms,
    FileUploads,
    LaravelEcho,
    DirtyStates,
    Polling
].forEach(fn => fn());

dispatch('livewire:available');

export default Livewire;

function monkeyPatchDomSetAttributeToAllowAtSymbols() {
    const original = Element.prototype.setAttribute;
    const hostDiv = document.createElement('div');

    Element.prototype.setAttribute = function (name, value) {
        if (!name.includes('@')) return original.call(this, name, value);

        hostDiv.innerHTML = `<span ${name}="${value}"></span>`;
        const attr = hostDiv.firstElementChild.getAttributeNode(name);
        hostDiv.firstElementChild.removeAttributeNode(attr);
        this.setAttributeNode(attr);
    };
}

monkeyPatchDomSetAttributeToAllowAtSymbols();
